@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<div class="content">
  <div class="inputRow">
    <mat-form-field class="inputField">
      <mat-label>Project Name</mat-label>
      <input #projectNameInput maxlength="30" matInput [(ngModel)]="scheduleInput.projectName"/>
      <mat-hint align="end">{{ projectNameInput.value.length }} / 30</mat-hint>
    </mat-form-field>
  </div>
  <div class="inputRow">
    <mat-form-field class="locationField">
      <mat-label>Location City</mat-label>
      <input #locationCityInput maxlength="50" matInput [(ngModel)]="scheduleInput.locationCity"/>
      <mat-hint align="end">{{ locationCityInput.value.length }} / 50</mat-hint>
    </mat-form-field>
    <mat-form-field class="locationField">
      <mat-label>Location State</mat-label>
      <input #locationStateInput maxlength="4" matInput [(ngModel)]="scheduleInput.locationState"/>
      <mat-hint align="end">{{ locationStateInput.value.length }} / 4</mat-hint>
    </mat-form-field>
    <mat-form-field class="locationField">
      <mat-label>Location Zip</mat-label>
      <input #locationPostalCodeInput maxlength="20" matInput [(ngModel)]="scheduleInput.locationZip"/>
      <mat-hint align="end">{{ locationPostalCodeInput.value.length }} / 20</mat-hint>
    </mat-form-field>
  </div>
  <div class="inputRow">
    <mat-form-field class="inputField">
      <mat-label>Notes</mat-label>
      <input matInput [(ngModel)]="scheduleInput.notes"/>
    </mat-form-field>
  </div>
  <div class="tableWrapper">
    <h4>Please select the loop(s) to use in the new Schedule</h4>
    <table mat-table [dataSource]="datasource" class="paginatedTable bordered-table">
      <ng-container matColumnDef="selected">
        <th class="buttonCell" mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null"
            [checked]="selection && selection.hasValue() && isAllSelected()"
            [indeterminate]="selection && selection.hasValue() && !isAllSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="col-xs">
          <mat-checkbox (click)="$event.stopPropagation()"
            (change)="$event ? toggleRowSelection(row) : null" [checked]="selection.isSelected(row)">
          </mat-checkbox>
        </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let loop">{{ loop.detail.description }}</td>
      </ng-container>
      <ng-container matColumnDef="coolingTotalCapacity">
        <th mat-header-cell *matHeaderCellDef>Cooling Cap</th>
        <td mat-cell *matCellDef="let loop">{{ loop.detail?.coolingActualTotalCapacity }}</td>
      </ng-container>
      <ng-container matColumnDef="heatingTotalCapacity">
        <th mat-header-cell *matHeaderCellDef>Heating Cap</th>
        <td mat-cell *matCellDef="let loop">{{ loop.detail?.heatingActualTotalCapacity }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
      <tr mat-row class="clickableRow" [class.selected]="selection.isSelected(row)" (click)="toggleRowSelection(row)" *matRowDef="let row; columns: displayColumns;"></tr>
    </table>
  </div>
  <div class="buttonRow">
    <span class="spacer"></span>
    <button class="dialogButton warn-button" matButton="elevated" (click)="cancel()">Cancel</button>
    <button class="dialogButton primary-button" matButton="elevated" [disabled]="!canSave()" (click)="save()">Save</button>
  </div>
</div>
